import script from "./FormGradeAndStatusBottomBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./FormGradeAndStatusBottomBlock.vue?vue&type=script&setup=true&lang=js"

import "./FormGradeAndStatusBottomBlock.vue?vue&type=style&index=0&id=d4546f46&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4546f46"]])

export default __exports__